import { render, staticRenderFns } from "./DiscoverMore.vue?vue&type=template&id=f6cf0d16&scoped=true&"
import script from "./DiscoverMore.vue?vue&type=script&lang=js&"
export * from "./DiscoverMore.vue?vue&type=script&lang=js&"
import style0 from "./DiscoverMore.vue?vue&type=style&index=0&id=f6cf0d16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6cf0d16",
  null
  
)

export default component.exports